import React from 'react';

const GRADIENTS = [
	'linear-gradient(145deg, #1a2d4a 0%, #2d4a7c 55%, #1a3a5c 100%)',
	'linear-gradient(145deg, #6b3a12 0%, #c7791f 55%, #8a4f14 100%)',
	'linear-gradient(145deg, #1e4a32 0%, #3f7a52 55%, #234a35 100%)',
	'linear-gradient(145deg, #3d2860 0%, #6a4fa0 55%, #4a2f6b 100%)',
	'linear-gradient(145deg, #1b2430 0%, #445b78 55%, #2a3d52 100%)',
	'linear-gradient(145deg, #5c2418 0%, #a8481f 55%, #7a2f1f 100%)',
];

function gradientFor(seed) {
	const s = String(seed || 'nepal');
	let hash = 0;
	for (let i = 0; i < s.length; i += 1) hash = (hash * 31 + s.charCodeAt(i)) >>> 0;
	return GRADIENTS[hash % GRADIENTS.length];
}

const ICONS = {
	national_park: 'fa-tree',
	unesco_site: 'fa-landmark',
	lake: 'fa-water',
	waterfall: 'fa-water',
	temple: 'fa-place-of-worship',
	monastery: 'fa-om',
	museum: 'fa-university',
	viewpoint: 'fa-mountain',
	other: 'fa-map-marker-alt',
	district: 'fa-map',
	province: 'fa-landmark',
	festival: 'fa-drum',
	guide: 'fa-book-open',
	government: 'fa-landmark',
	transportation: 'fa-route',
	living_in_nepal: 'fa-house-user',
	seasonal: 'fa-cloud-sun',
	trends: 'fa-arrow-trend-up',
};

const CATEGORY_SHORT = {
	national_park: 'National Park',
	unesco_site: 'UNESCO Site',
	lake: 'Lake',
	waterfall: 'Waterfall',
	temple: 'Temple',
	monastery: 'Monastery',
	museum: 'Museum',
	viewpoint: 'Trek',
	other: 'Nepal',
};

export function iconFor(category) {
	return ICONS[category] || 'fa-mountain';
}

function MediaFrame({ src, category, icon: iconOverride, seed, alt, variant = 'thumb', children, className = '' }) {
	const icon = iconOverride || iconFor(category);
	const displayName = alt || CATEGORY_SHORT[category] || 'Nepal';

	if (src) {
		return (
			<div className={`media-frame media-frame--${variant} ${className}`}>
				<img className="media-frame__img" src={src} alt={alt || ''} loading={variant === 'thumb' ? 'lazy' : undefined} />
				{children}
			</div>
		);
	}

	const initial = (displayName || 'N').charAt(0).toUpperCase();

	return (
		<div
			className={`media-frame media-frame--${variant} media-frame--placeholder ${className}`}
			style={{ background: gradientFor(seed || category || alt) }}
			role="img"
			aria-label={alt || displayName}
		>
			<div className="media-frame__placeholder-bg" aria-hidden="true" />
			<div className="media-frame__placeholder-mark">
				<span className="media-frame__initial">{initial}</span>
				<i className={`fas ${icon} media-frame__icon`} aria-hidden="true" />
				{variant === 'thumb' && (
					<span className="media-frame__placeholder-name">{displayName}</span>
				)}
			</div>
			{children}
		</div>
	);
}

export default MediaFrame;
